module.exports = "<div class=\"access-container\">\r\n  <h1>403 - Access Denied</h1>\r\n  <p>You are not authorized to view this page.</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/access-denied/access-denied.component.html
// module id = 1032
// module chunks = 1